// extracted by mini-css-extract-plugin
export default {"phoneParams":"ProductParams_phoneParams__rzcnS","phoneParams__techSpecs":"ProductParams_phoneParams__techSpecs__vIxFG"};